import React, { Component } from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import { withTranslation } from 'react-i18next';
import { Col } from 'reactstrap';
import * as statistics from './Services/statisticsService';
import UserActionsTable from './Components/Tables/userActionsTable';
import * as adminService from '../Application/Services/adminService';
import Select from 'react-select';
import Pagination from './Components/shared/pagination';
import { SpinnerLoader } from './Components/shared/spinnerLoader';

let UserActionParams = { userId: 0, PageNumber: 1, PageSize: 10 };

class UserActions extends Component {
  state = {
    loading: true,
    userActions: [],
    // pagination
    selectedPage: 1,
    itemsPerPage: 25,
    totalItems: 0,
    // selects
    tags: [{ value: 25, label: '25' }],
  };

  async componentDidMount() {
    const { data: userActions, headers } = await statistics.getUserActions(0);
    const { data: users } = await adminService.getUsersForAdminUser();
    const obj = JSON.parse(headers.pagination);

    this.setState({
      users: users,
      selectedPage: 1,
      itemsPerPage: obj.itemsPerPage,
      totalItems: obj.totalItems,
      userActions,
      UserActionParams: UserActionParams,
      loading: false,
    });
  }

  getUsersForSelect() {
    let users = this.state.users?.map((user, index) => {
      return { value: user.id, label: user.username };
    });

    return users;
  }

  onSelectedUserChanged = async (item) => {
    if (item && item.value) {
      UserActionParams.userId = item.value;
      this.setState({ loading: true, selectedUser: item });
      const { data: userActions, headers } = await statistics.getUserActions(UserActionParams);
      const obj = JSON.parse(headers.pagination);

      this.setState({
        selectedPage: 1,
        itemsPerPage: obj.itemsPerPage,
        totalItems: obj.totalItems,
        userActions,
        UserActionParams: UserActionParams,
        loading: false,
      });
    } else {
      UserActionParams.userId = 0;
      this.setState({ loading: true, selectedUser: null });
      const { data: userActions, headers } = await statistics.getUserActions(UserActionParams);
      const obj = JSON.parse(headers.pagination);

      this.setState({
        selectedPage: 1,
        itemsPerPage: obj.itemsPerPage,
        totalItems: obj.totalItems,
        userActions,
        UserActionParams: UserActionParams,
        loading: false,
      });
    }
  };

  // change number of items in the table
  handleChangeSelect = async (name, newVal) => {
    UserActionParams.PageSize = newVal.value;
    UserActionParams.PageNumber = 1;
    const { data: userActions, headers } = await statistics.getUserActions(UserActionParams);

    this.setState({
      [name]: newVal,
      userActions,
      itemsPerPage: newVal.value,
      selectedPage: 1,
    });
  };

  async handlePaginationSelected(selectedPageX) {
    this.setState({ loading: true });
    UserActionParams.PageNumber = selectedPageX;
    const { data: userActions, headers } = await statistics.getUserActions(UserActionParams);
    this.setState({ userActions, selectedPage: selectedPageX, loading: false });
  }

  render() {
    const { t } = this.props;
    const userActions = this.state.userActions;
    return (
      <ContentWrapper>
        {/* <FadeIn> */}
        <div className="content-heading">
          <Col md={10}>
            {t('userActions.USER_ACTIONS')}&nbsp;
            <small>{t('userActions.NOTE')}</small>
          </Col>
        </div>
        <div style={{ position: 'relative', zIndex: '3' }}>
          <div style={{ width: '300px' }}>
            <Select
              name="onSelectUserChanged"
              value={this.state.selectedUser}
              onChange={(item) => this.onSelectedUserChanged(item)}
              options={this.getUsersForSelect()}
              placeholder="Select user..."
              isClearable={true}
            />
          </div>
        </div>
        {/* </FadeIn> */}
        {this.state.loading ? (
          <SpinnerLoader />
        ) : (
          <div>
            {/* <FadeIn> */}
            <UserActionsTable userActions={userActions} />
            <Pagination
              totalItems={this.state.totalItems}
              pageSize={this.state.itemsPerPage}
              activePage={this.state.selectedPage}
              onPaginationSelect={(item) => this.handlePaginationSelected(item)}
              onTableSizeSelect={this.handleChangeSelect.bind(this, 'tags')}
              tags={this.state.tags}
            ></Pagination>
            {/* </FadeIn> */}
          </div>
        )}
      </ContentWrapper>
    );
  }
}

export default withTranslation('translations')(UserActions);
